<template>
  <form class="search-container glass" role="search" @submit.prevent="onSubmit">
    <i class="fas fa-magnifying-glass search-icon" aria-hidden="true"></i>
    <input
      v-model="city"
      type="search"
      class="city-input"
      placeholder="Enter city name"
      aria-label="City name"
      autocomplete="off"
      spellcheck="false"
      enterkeyhint="search"
    />
    <button
      type="button"
      class="locate-btn"
      :disabled="loading"
      aria-label="Use my location"
      title="Use my location"
      @click="$emit('locate')"
    >
      <i class="fas fa-location-crosshairs" aria-hidden="true"></i>
    </button>
    <button type="submit" :disabled="loading" class="search-btn">
      <i v-if="loading" class="fas fa-spinner fa-spin" aria-hidden="true"></i>
      {{ loading ? "Loading..." : "Get Weather" }}
    </button>
  </form>
</template>

<script>
export default {
  name: "SearchBar",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["search", "locate"],
  data() {
    return {
      city: "",
    };
  },
  methods: {
    onSubmit() {
      this.$emit("search", this.city.trim());
    },
  },
};
</script>

<style scoped>
.locate-btn {
  display: grid;
  flex-shrink: 0;
  place-items: center;
  width: 36px;
  height: 36px;
  color: var(--color-text-muted);
  background: transparent;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition:
    color var(--transition-fast),
    background-color var(--transition-fast);
}

.locate-btn:hover:not(:disabled) {
  color: var(--color-text);
  background-color: color-mix(in srgb, currentColor 12%, transparent);
}

.locate-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.search-container {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  width: 100%;
  padding: var(--space-1) var(--space-1) var(--space-1) var(--space-4);
  border-radius: var(--radius-full);
  transition: box-shadow var(--transition-fast);
}

.search-container:focus-within {
  box-shadow:
    0 0 0 3px var(--color-focus-ring),
    var(--glass-shadow);
}

.search-icon {
  color: var(--color-text-muted);
}

.city-input {
  flex: 1;
  min-width: 0;
  padding: var(--space-2) 0;
  background: transparent;
  border: none;
  -webkit-appearance: none;
  appearance: none;
}

.city-input::placeholder {
  color: var(--color-text-muted);
}

.city-input:focus-visible {
  outline: none;
}

.search-btn {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-5);
  font-weight: var(--font-weight-medium);
  color: var(--color-on-primary);
  background-color: var(--color-primary);
  border: none;
  border-radius: var(--radius-full);
  cursor: pointer;
  transition: background-color var(--transition-base);
}

.search-btn:hover:not(:disabled) {
  background-color: var(--color-primary-hover);
}

.search-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (min-width: 768px) {
  .search-container {
    max-width: 420px;
  }
}
</style>
